import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import {
  signOut,
  resetPassword,
  getPoliciesSummary,
  getPoliciesForVertical,
  getPolicyById,
  showMenu,
  hideMenu,
  hideToast,
  showToast,
  updateAccountInfo,
  getL10n,
  addPaymentMethod,
  deletePaymentMethod,
  getCollectiblesCategories,
  updateCollectiblesEndorsementAddress,
  getCollectiblesEndorsementRemoveCheckout,
  submitCollectiblesEndorsementRemove,
  resetCollectiblesEndorsementData,
  startRentalCarExtension,
  getCancelPolicyCheckout,
  cancelPolicy,
} from '../../store/actions';
import { Modal, RadioButton } from 'sure-components';
import { SingleDatePicker } from 'react-dates';
import filter from 'lodash/filter';
import findKey from 'lodash/findKey';
import flatten from 'lodash/flatten';
import includes from 'lodash/includes';
import kebabCase from 'lodash/kebabCase';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import ModalCancelPolicy from '../../components/ModalCancelPolicy';
import Toast from '../../components/Toast';
import TopNavBar from '../../components/TopNavBar';
import * as analytics from 'shared/lib/analytics';
import moment from 'moment-timezone';
import VERTICALS from 'shared/lib/constants/verticals';
import COLLECTIBLES_CATEGORIES from 'shared/lib/constants/collectiblesCategories';
import withGlobals from '../../withGlobals';

class AccountContainer extends Component {
  constructor(props) {
    super(props);
    this.MODALS = {
      CANCEL_POLICY: 'CANCEL_POLICY',
      RENTAL_CAR_EXTENSION: 'RENTAL_CAR_EXTENSION',
      SELECT_COLLECTIBLES_CATEGORY: 'SELECT_COLLECTIBLES_CATEGORY',
    };
    this.state = {
      activeModal: null,
      isDatePickerOpen: false,
    };
    this.isMobile = window.innerWidth < 768;
  }

  componentDidMount() {
    document.title = 'Your Account | Sure';
    this.props.getCollectiblesCategories();
  }

  hideModals = () => {
    this.setState({
      activeModal: null,
    });
  };

  recursiveFlattenCategories(categories = []) {
    return flatten(
      map(categories, category => {
        if (category.sub_categories.length) {
          return this.recursiveFlattenCategories(category.sub_categories);
        } else {
          return category;
        }
      })
    );
  }

  handleRentalCarExtensionSubmit = momentObj => {
    if (momentObj) {
      analytics.track('Rental Car - Extended End Date', {
        category: 'policy',
        label: this.policy.id,
        value: momentObj.diff(
          moment(this.policy.details.end_payment_period),
          'days'
        ),
      });
      analytics.track('Checkout Step Viewed', {
        category: 'order',
        step: 1,
      });
      this.props.startRentalCarExtension(this.policy.id, momentObj);
      this.hideModals();
      this.props.navTo(`/rental-car-insurance/extension/${this.policy.id}`);
    }
  };

  showSelectCollectiblesCategoryModal = ({ onSelect }) => {
    this.setState({
      activeModal: this.MODALS.SELECT_COLLECTIBLES_CATEGORY,
      onSelectCollectiblesCategory: onSelect,
    });
  };

  handleSelectCollectiblesExistingOwner = e => {
    this.hideModals();
    this.props.navTo(
      `/account/policies/collectibles/${this.policy.id}/add/${e.target.value}`
    );
  };

  handleSelectCollectiblesNewOwner = e => {
    const urlKey = findKey(COLLECTIBLES_CATEGORIES, {
      categoryCode: e.target.value,
    });
    this.props.navTo(`/collectibles/${kebabCase(urlKey)}-insurance/start`);
  };

  handleAddToCollection = () => {
    this.props.resetCollectiblesEndorsementData();
    this.props.showGlobalModal({
      id: 'collectiblesAddToExisting',
      policies: filter(this.props.policiesById, {
        status: 'approved',
        vertical_code: VERTICALS.collectibles.code,
      }),
      onSelectExistingOwner: policyId => {
        this.props.hideGlobalModal();
        this.showSelectCollectiblesCategoryModal({
          onSelect: this.handleSelectCollectiblesExistingOwner,
        });
      },
      onCreateNewOwner: () => {
        this.props.hideGlobalModal();
        this.showSelectCollectiblesCategoryModal({
          onSelect: this.handleSelectCollectiblesNewOwner,
        });
      },
    });
  };

  handleDatePickerFocus = ({ focused }) => {
    this.setState({
      isDatePickerOpen: focused,
    });
  };

  showRentalCarExtensionModal = () => {
    analytics.track('Policy Management - Rental car extension button tapped');
    this.setState({
      activeModal: this.MODALS.RENTAL_CAR_EXTENSION,
    });
  };

  showCancelPolicyModal = policyId => {
    this.setState({
      activeModal: this.MODALS.CANCEL_POLICY,
    });
  };

  get filteredCollectiblesCategories() {
    const flattenedCategories = this.recursiveFlattenCategories(
      this.props.collectiblesCategories
    );
    const existingCategoryCodes = map(
      this.policy.details.collections,
      'category.code'
    );
    const filteredCategories = filter(
      flattenedCategories,
      category => !includes(existingCategoryCodes, category.code)
    );
    return sortBy(filteredCategories, ['name']);
  }

  get policy() {
    return this.props.policiesById[this.props.params.policyId] || {};
  }

  render() {
    return (
      <div className="AccountContainer">
        {!this.props.isEmbed && (
          <TopNavBar
            isLoggedIn={this.props.isLoggedIn}
            userFullName={this.props.userFullName}
            isMenuOpen={this.props.isMenuOpen}
            activeLink={this.props.location.pathname}
            isFixed
            onHideMenu={this.props.hideMenu}
            onShowMenu={this.props.showMenu}
          />
        )}
        {React.cloneElement(this.props.children, {
          ...omit(this.props, ['children']),
          handleAddToCollection: this.handleAddToCollection,
          handleCancelPolicy: this.showCancelPolicyModal,
          onRentalCarExtend: this.showRentalCarExtensionModal,
        })}
        {this.props.toast && (
          <Toast
            message={this.props.toast.message}
            sureStyle={this.props.toast.style}
            onDismiss={this.props.hideToast}
          />
        )}

        {this.state.activeModal === this.MODALS.CANCEL_POLICY && (
          <ModalCancelPolicy
            policy={this.policy}
            onDismiss={this.hideModals}
            onCancel={this.props.cancelPolicy}
            onError={this.props.onError}
            getPolicyById={this.props.getPolicyById}
            getCancelPolicyCheckout={this.props.getCancelPolicyCheckout}
          />
        )}
        {this.state.activeModal === this.MODALS.RENTAL_CAR_EXTENSION && (
          <Modal
            title="Extend your rental car coverage"
            isActive={true}
            onDismiss={this.hideModals}
          >
            <div style={{ minHeight: '450px' }}>
              <p>Select your new return date:</p>
              <SingleDatePicker
                date={moment(this.policy.details.rental_ended)
                  .tz('UTC')
                  .add(1, 'day')}
                focused={true}
                noBorder={true}
                numberOfMonths={1}
                orientation={this.isMobile ? 'vertical' : 'horizontal'}
                withFullScreenPortal={this.isMobile}
                displayFormat={'MM/DD/YYYY'}
                isOutsideRange={day =>
                  moment(day)
                    .tz('UTC')
                    .startOf('day')
                    .isSameOrBefore(
                      moment(this.policy.details.rental_ended).tz('UTC')
                    )
                }
                onDateChange={this.handleRentalCarExtensionSubmit}
                onClose={this.hideModals}
                onFocusChange={this.handleDatePickerFocus}
                hideKeyboardShortcutsPanel
                id="return_date"
              />
            </div>
          </Modal>
        )}
        {this.state.activeModal ===
          this.MODALS.SELECT_COLLECTIBLES_CATEGORY && (
          <Modal
            title="Select a category"
            isActive={true}
            onDismiss={this.hideModals}
          >
            <p>What type of collection would you like to insure?</p>
            {map(this.filteredCollectiblesCategories, category => (
              <RadioButton
                key={category.code}
                name="category"
                title={category.name}
                value={category.code}
                onChange={this.state.onSelectCollectiblesCategory}
              />
            ))}
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    account: state.account,
    collectiblesCategories: state.collectiblesCategories,
    countries: state.countries,
    isAddPaymentMethodInProgress: state.isAddPaymentMethodInProgress,
    isAddPaymentMethodModalActive: state.activeModal === 'addPaymentMethod',
    isDeletePaymentMethodModalActive:
      state.activeModal === 'deletePaymentMethod',
    isEmbed: state.isEmbed,
    isFetchingOrders: state.isFetchingOrders,
    isFetchingPolicies: state.isFetchingPolicies,
    isLoggedIn: !!state.authToken,
    isMenuOpen: state.isMenuOpen,
    policiesById: state.policiesById,
    mostRecentPoliciesByVertical: mapValues(
      state.mostRecentPolicyIdsByVertical,
      policyIdsArr => {
        return map(policyIdsArr, policyId => state.policiesById[policyId]);
      }
    ),
    policiesTotalsByVertical: state.policiesTotalsByVertical,
    toast: state.toast,
    userFullName: `${state.account.firstName} ${state.account.lastName}`,
    verticalCode: ownProps.params.verticalCode,
    verticals: uniq(map(state.policiesById, 'vertical_code')),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      {
        showMenu,
        hideMenu,
        hideToast,
        getPoliciesSummary,
        getPoliciesForVertical,
        getPolicyById,
        getCancelPolicyCheckout,
        cancelPolicy,
        resetPassword,
        startRentalCarExtension,
        getCollectiblesCategories,
        showToast,
        getL10n,
        updateAccountInfo,
        addPaymentMethod,
        deletePaymentMethod,
        updateCollectiblesEndorsementAddress,
        resetCollectiblesEndorsementData,
      },
      dispatch
    ),
    signOut: () => {
      // ccody
      // Could there be an issue since dispatch is async, and push() happens before signOut() action?
      // is it possible `push` can happen first, so signout never happens?
      dispatch(signOut());
      dispatch(push('/'));
    },
    navTo: bindActionCreators(push, dispatch),
    getEndorsementRemoveCheckout: bindActionCreators(
      getCollectiblesEndorsementRemoveCheckout,
      dispatch
    ),
    submitEndorsementRemove: bindActionCreators(
      submitCollectiblesEndorsementRemove,
      dispatch
    ),
  };
};

const enhance = compose(
  withRouter,
  withGlobals({
    analyticsPrefix: 'Portal',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(AccountContainer);
